import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_BASE } from "../apiBase";
import { ownerSecretHeader } from '../ownerSecret';

export const CreateVspeedPage = () => {

    const [name, setName] = useState('');
    const [configuration, setConfig] = useState('');
    const [Vspeed1, setVs] = useState('');
    const [Vspeed2, setVs2] = useState('');
    const [units, setUnits] = useState('MPH');

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const tail = (searchParams.get("tail") || "").trim().toUpperCase();

    const addVspeed = async () => {

        const newVspeed = {
            name,
            configuration,
            Vspeed1,
            Vspeed2,
            units
        };

        const response = await fetch(
            `${API_BASE}/api/vspeeds?tail=${encodeURIComponent(tail)}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...ownerSecretHeader(tail),
                },
                body: JSON.stringify(newVspeed),
            }
        );

        if (response.status === 201 || response.status === 200) {
            alert("Successfully added the vspeed!");
        } else if (response.status === 403) {
            alert("You're not authorized to add vspeeds to this aircraft.");
        } else {
            alert(`Failed to add vspeed, status code = ${response.status}`);
        }

        navigate('/vsps');
    };

    return (
        <div>
            <p>Add Vspeed for aircraft: <b>{tail}</b></p>

            <table id="add-vspeeds">
                <thead>
                    <tr>
                        <th className='name_box'>Name</th>
                        <th className='config_box'>Configuration</th>
                        <th className='speed_box'>Vspeed1</th>
                        <th className='speed_box'>Vspeed2</th>
                        <th className='unit_box'>Units</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td className='name_box'>
                            <input type="text" value={name} onChange={e => setName(e.target.value)} />
                        </td>
                        <td className='config_box'>
                            <input type="text" value={configuration} onChange={e => setConfig(e.target.value)} />
                        </td>
                        <td className='speed_box'>
                            <input type="number" value={Vspeed1} onChange={e => setVs(e.target.value)} />
                        </td>
                        <td className='speed_box'>
                            <input type="number" value={Vspeed2} onChange={e => setVs2(e.target.value)} />
                        </td>
                        <td className='unit_box'>
                            <select value={units} onChange={e => setUnits(e.target.value)}>
                                <option>MPH</option>
                                <option>KTS</option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div style={{ marginTop: '20px' }}>
                <button onClick={addVspeed}>Add</button>
            </div>
        </div>
    );
}

export default CreateVspeedPage;